import { render, staticRenderFns } from "./slproduct-add-or-update copy.vue?vue&type=template&id=76ee3543&scoped=true&"
import script from "./slproduct-add-or-update copy.vue?vue&type=script&lang=js&"
export * from "./slproduct-add-or-update copy.vue?vue&type=script&lang=js&"
import style0 from "./slproduct-add-or-update copy.vue?vue&type=style&index=0&id=76ee3543&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ee3543",
  null
  
)

export default component.exports